/**
 * File: KnowledgeBaseWelcomeStep.tsx
 * Description: Second step of the welcome flow. Reuses the Knowledge Base
 *   page in selection mode so the user can pre-pick guideline documents
 *   that will be seeded into every new project.
 * Author: GitHub Copilot
 * Created: 2026-05-31
 * Last Modified: 2026-05-31
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { KnowledgeBasePage } from './KnowledgeBasePage';

export const KnowledgeBaseWelcomeStep: React.FC = () => {
  const navigate = useNavigate();
  return (
    <KnowledgeBasePage
      selectionMode
      onConfirm={() => navigate('/', { replace: true })}
      onBack={() => navigate('/welcome', { replace: true })}
    />
  );
};

export default KnowledgeBaseWelcomeStep;
